import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { useAuth } from '@/hooks/useAuth';

export function SiteHeader() {
  const { user } = useAuth();

  const getCompanyName = () => {
    if (!user) return 'Urban Finch';

    if (user.role.includes('super_admin')) {
      return 'Urban Finch Admin';
    }

    return user.organization?.name || 'Urban Finch';
  };

  const companyName = getCompanyName();

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" data-testid="sidebar-toggle" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <h1 className="text-base font-medium">{companyName}</h1>
      </div>
    </header>
  );
}
